import { Alert, Descriptions, Tag, Typography, Button } from "antd";
import { fmt, STATUS_META } from "./tenantPaymentHelpers";

const { Text } = Typography;

interface Props {
  billing: any;
  onAssignPackage?: () => void;
}

export const TenantBillingSummary: React.FC<Props> = ({
  billing,
  onAssignPackage,
}) => {
  const b = billing;
  const status = b?.status;
  const meta = status ? STATUS_META[status] : null;

  return (
    <>
      {!b.package && (
        <Alert
          type="warning"
          showIcon
          message="No package assigned"
          description={
            <span className="text-xs">
              Monthly billing requires an assigned package. Assign one to
              enable subscription billing for this tenant.
              {onAssignPackage && (
                <Button
                  type="link"
                  size="small"
                  className="!px-1"
                  onClick={onAssignPackage}
                >
                  Assign package
                </Button>
              )}
            </span>
          }
        />
      )}
      <Descriptions
        column={1}
        size="small"
        bordered
        className="text-xs"
        labelStyle={{ width: 160 }}
      >
        <Descriptions.Item label="Status">
          {meta && <Tag color={meta.color}>{meta.label(b)}</Tag>}
        </Descriptions.Item>
        <Descriptions.Item label="Package">
          {b.package ? (
            b.package.package_name
          ) : (
            <Text type="secondary">No package assigned</Text>
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Monthly Amount">
          <Text strong>{fmt(b.monthly_amount)}</Text>
        </Descriptions.Item>
        <Descriptions.Item label="Billing Day (monthly)">
          {b.billing_day}
        </Descriptions.Item>
        <Descriptions.Item label="Current Due Date">
          {b.current_due_date}
        </Descriptions.Item>
        <Descriptions.Item label="Days Until Due">
          {b.days_until_due}
        </Descriptions.Item>
        <Descriptions.Item label="System Enabled">
          <Tag color={b.is_enabled ? "green" : "red"}>
            {b.is_enabled ? "Enabled" : "Disabled"}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Terminated">
          <Tag color={b.is_terminated ? "volcano" : "green"}>
            {b.is_terminated ? "Yes" : "No"}
          </Tag>
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};
